module.exports = __webpack_public_path__ + "img/custom.b052ba5d.png";